import { getSupplierPerformanceEvalutionDetail } from "@/apis/supplier";
import { useQuery } from "@tanstack/react-query";
import type { EvaluationResultDataType } from "../type";

export function usePerformanceEvaluationResultQuery(editingId?: number | null) {
  const result = useQuery({
    queryKey: ["performanceEvaluationDetail", editingId],
    queryFn: () => getSupplierPerformanceEvalutionDetail(editingId!),
    enabled: !!editingId,
  });

  const evalutionResultData: EvaluationResultDataType[] = [];

  result.data?.data.data.dimensions.forEach((dim) => {
    dim.indicatorDetails.forEach((i) => {
      const raters = Object.groupBy(dim.indicatorDetails, (item) =>
        item.rater.toString(),
      );
      const raterScores: Record<string, number> = {};
      for (const key of Object.keys(raters)) {
        const raterData = raters[key];
        if (!raterData) {
          continue;
        }
        const totalScore = raterData.reduce(
          (acc, cur) => acc + (cur.score || 0) * cur.weight,
          0,
        );
        raterScores[key] = totalScore / 100;
      }

      evalutionResultData.push({
        key: i.id,
        dimensionId: dim.dimensionId,
        dimensionName: dim.dimensionName,
        indicatorId: i.indicatorId,
        indicator2Name: i.indicator2Name,
        level1Remarks: i.level1Remarks,
        level2Remarks: i.level2Remarks,
        level3Remarks: i.level3Remarks,
        level4Remarks: i.level4Remarks,
        score: i.score,
        weight: i.weight,
        ratingDeptId: i.ratingDeptId,
        rater: i.rater,
        raterUserName: i.raterUserName,
        dimensionScore:
          raterScores[i.rater.toString()] || (null as unknown as number),
      });
    });
  });

  return {
    queryResult: result.data?.data.data,
    evalutionResultData,
  };
}
